import { render, staticRenderFns } from "./createDynamic.vue?vue&type=template&id=49acd977&scoped=true&"
import script from "./createDynamic.vue?vue&type=script&lang=js&"
export * from "./createDynamic.vue?vue&type=script&lang=js&"
import style0 from "./createDynamic.vue?vue&type=style&index=0&id=49acd977&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49acd977",
  null
  
)

export default component.exports